export default "__VITE_ASSET__CtpW3oq$__"